(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
        const sliders = document.querySelectorAll('.reviews-slider');

        if (!sliders.length) {
            return;
        }

        sliders.forEach((slider) => {
            const $slider = $(slider);

            $slider.slick({
                slidesToShow: 1,
                // slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 600,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnHover: false,
                centerMode: true,

            });
        });
    });
})(jQuery);